"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIntersectingEntries = void 0;
function getIntersectingEntries(obj, template) {
    // This has to be force cast as the type of Object.entries and Object.keys do not reflect the type of the passed in object
    const allEntries = Object.entries(obj);
    const keys = Object.keys(template);
    // Don't allow extra parameters to be snuck in
    return allEntries.filter(([k, _v]) => keys.includes(k));
}
exports.getIntersectingEntries = getIntersectingEntries;
//# sourceMappingURL=getIntersectingEntries.js.map